function caseStudiesPage(init, { solutions, industries, t }) {
  const context = {};
  const btnText = $(".btn-more .btn").html();
  let total = 0;
  let by = "all";
  let value = null;
  context.page = 1;
  context.list = new Proxy([], {
    set(array, property, value, receive) {
      array = array.filter((item) => item !== undefined);
      context.render([...array]);
      if (array.length >= total || array.length === 0) {
        $(".btn-more").hide();
      } else {
        $(".btn-more").show();
      }
      return Reflect.set(...arguments);
    },
  });
  context.start = () => {
    context.fetchMeta((total) => {
      if (total > 0) {
        context.drawFilters();
      }
    });
  };
  context.search = () => {
    context.fetchMeta();
  };
  context.fetchMeta = (callback = null) => {
    context.page = 1;
    context.list.splice(0, context.list.length);
    $.ajax({
      type: "get",
      url: window.toUrl
        .replace("__ACTION__", "case-studies-meta")
        .replace("__PAGE__", 1)
        .replace("__SIZE__", 0)
        .replace("__BY__", by)
        .replace("__VALUE__", value),
      dataType: "json",
      success(count) {
        total = parseInt(count);
        if (callback) {
          callback(total);
        }
        context.fetchCategories();
      },
      error(xhr, ajaxOptions, thrownError) {
        console.log(
          "There was a problem loading that page. You may need to refresh."
        );
      },
    });
  };
  context.drawFilters = () => {
    const temp = `
        <a href="#" class="filter-type all${by === "all" ? " active" : ""}">${
      t["All"]
    }</a>
        <div class="dropdown filter-type solutions${
          by === "solutions" ? " active" : ""
        }">
            <button class="btn dropdown-toggle" type="button" id="filter-by-solutions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                ${t["By Solutions"]}
            </button>
            <div class="dropdown-menu" aria-labelledby="filter-by-solutions">
                ${solutions
                  .map(
                    (item) => `
                <a class="dropdown-item" href="#" data-id="${item.value}" data-by="solutions">${item.label}</a>
                `
                  )
                  .join("")}
            </div>
        </div>
        <div class="dropdown filter-type industries${
          by === "industries" ? " active" : ""
        }">
            <button class="btn dropdown-toggle" type="button" id="filter-by-industries" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                ${t["By Industries"]}
            </button>
            <div class="dropdown-menu" aria-labelledby="filter-by-industries">
                ${industries
                  .map(
                    (item) => `
                <a class="dropdown-item" href="#" data-id="${item.value}" data-by="industries">${item.label}</a>
                `
                  )
                  .join("")}
            </div>
        </div>
        <form class="filter-type search${by === "search" ? " active" : ""}">
            <div class="input-group">
                <input type="text" class="form-control" placeholder="${
                  t["Search Case Study"]
                }" aria-label="${
      t["Search Case Study"]
    }" aria-describedby="search-case-study" name="keyword">
                <div class="input-group-append">
                    <button class="btn" type="submit" id="search-case-study">
                        <span class="fas fa-search"></span>
                    </button>
                </div>
            </div>
        </form>
    `;
    $(".filters").html(temp);
    $(".filter-type.all").on("click", function (e) {
      e.preventDefault();
      context.selectFilter("all");
    });
    $(".filter-type .dropdown-menu .dropdown-item").on("click", function (e) {
      e.preventDefault();
      context.selectFilter($(this).data("by"), $(this).data("id"));
    });
    $(".filter-type.search").on("submit", function (e) {
      e.preventDefault();
      context.selectFilter("search", $(this).find(".form-control").val());
    });
  };
  context.selectFilter = (selectBy, selectValue = null) => {
    if (selectBy === "search" && !selectValue) {
      selectBy = "all";
    }
    let label = selectValue;
    if(['solutions'].includes(selectBy)){
      label = solutions.find(item => parseInt(item.value) === parseInt(selectValue))?.label || "N/A";
    }else if(['industries'].includes(selectBy)){
      label = industries.find(item => parseInt(item.value) === parseInt(selectValue))?.label || "N/A";
    }
    by = selectBy;
    value = selectValue;
    $(".filters .filter-type.active").removeClass("active");
    $(`.filters .filter-type.${by}`).addClass("active");
    $(".by-title.active").removeClass("active");
    $(`.by-title.${by} .value`).html(label);
    $(`.by-title.${by}`).addClass("active");
    context.search();
  };
  context.fetchCategories = () => {
    $.ajax({
      type: "get",
      url: window.toUrl
        .replace("__ACTION__", "case-studies")
        .replace("__PAGE__", context.page)
        .replace("__SIZE__", 8)
        .replace("__BY__", by)
        .replace("__VALUE__", value),
      dataType: "json",
      beforeSend() {
        $(".btn-more .btn").html(
          '<span class="fas fa-spinner fa-spin"></span> Loading...'
        );
      },
      success(response) {
        response.forEach((item) => {
          context.list.push(item);
        });
        context.page++;
      },
      error(xhr, ajaxOptions, thrownError) {
        console.log(
          "There was a problem loading that page. You may need to refresh."
        );
      },
      complete() {
        $(".btn-more .btn").html(btnText);
      },
    });
  };
  context.render = (list) => {
    if (list.length > 0) {
      const temp = `
        ${list
          .map(
            (content) => `
            ${context.contentTemplate(content)}
            `
          )
          .join("")}
      `;
      $(".posts").html(temp);
    } else {
      $(".posts").html(`<div class="text-muted">${t["No case studies found"]}</div>`);
    }
  };

  context.contentTemplate = (content) => {
    return `
        <a href="${content.url}" class="item" style="--image:url('${
          content.case_study_image?.url || null
        }');--logo:url('${content.case_study_logo?.url || null}');">
            <div class="info">
                <h2 class="title">${content.local.title}</h2>
                <div class="excerpt">${content.local.excerpt}</div>
            </div>
        </a>
    `;
  };

  $(".btn-more").on("click", context.fetchCategories);

  init(context);
}

window.caseStudiesPage = caseStudiesPage;
